import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/firebaseAuth';
import { getDocumentById } from '../../utility/firebaseHelpers';

interface BanCheckWrapperProps {
  children: React.ReactNode;
}

const BanCheckWrapper: React.FC<BanCheckWrapperProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkBanStatus = async () => {
      // Don't check if on banned page or login/signup pages
      if (
        location.pathname === '/account-banned' ||
        location.pathname === '/login' ||
        location.pathname === '/signup' ||
        !currentUser
      ) {
        setChecking(false);
        return;
      }

      try {
        const userDoc = await getDocumentById('users', currentUser.uid);
        
        if (userDoc?.status === 'banned') {
          navigate('/account-banned', { replace: true });
          return;
        }
      } catch (error) {
        console.error('Error checking ban status:', error);
      } finally {
        setChecking(false);
      }
    };

    checkBanStatus();
  }, [currentUser, navigate, location.pathname]);

  if (checking) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return <>{children}</>;
};

export default BanCheckWrapper;
